//基金机构 新建 step1
export const newStep1 = [{
    label: "机构名称(全称)",
    formtype: "",
    field: "institutionName",
    require: true,
    rules: [{ required: false, message: '', trigger: 'blur' },{  max: 100, message: '输入不能超过100位', trigger: 'blur' }],
    disabled: false,
}, {
    label: '基金管理人',
    formtype: "",
    field: "managerType",
    require: false,
    rules: [{ required: false, message: '', trigger: 'blur' },{  max: 255, message: '输入不能超过255位', trigger: 'blur' }],
}, {
    label: '机构成立日期',
    formtype: "date",
    field: "fundSetDate",
    require: false
},
{
    label: "认缴出资额(万元)",
    formtype: "",
    field: "capitalAdmitted",
    inputType: "number",
    rules: [{ required: false, message: '', trigger: 'blur' },{  max: 16, message: '输入不能超过16位', trigger: 'blur' }],
    require: false
},
{
    label: "统一社会信用代码（组织机构代码）",
    formtype: "",
    field: "associationNo",//organizationalType
    require: false,
    rules: [{ required: false, message: '', trigger: 'blur' },{  max: 18, message: '请输入正确的统一社会信用代码（组织机构代码）', trigger: 'blur' }],
},
{
    label: "实缴出资额(万元)",
    formtype: "",
    field: "capitalPaid",
    rules: [{ required: false, message: '', trigger: 'blur' },{  max: 16, message: '输入不能超过16位', trigger: 'blur' }],
    inputType: "number",
    require: false
},
{
    label: "机构类型",
    formtype: "select",
    options: [
        {
            label: "私募股权投资基金",
            value: "私募股权投资基金",
        },
        {
            label: "创业投资基金",
            value: "创业投资基金",
        },
        {
            label: "私募证券投资基金",
            value: "私募证券投资基金",
        },
        {
            label: "持股平台",
            value: "持股平台",
        },
        {
            label: "自有资金投资类企业",
            value: "自有资金投资类企业",
        },

    ],
    field: "fundType",
    require: true
},
{
    label: "是否完成中国证券投资基金业协会登记/备案",
    formtype: "select",
    options: [
      {
        label: "是",
        value: '1',
      },
      {
        label: "否",
        value: '0',
      },
    ],
    field: "associationRegisteFinished",
    require: false,
},
{
    label: "是否托管",
    formtype: "select",
    options: [{
        label: "是",
        value: '1'
    },
    {
        label: "否",
        value: '0'
    }
    ],
    field: "autoManaged",
    require: false
},


{
    label: '产品备案时间',
    formtype: "date",
    field: "productRecordedDate",
    require: false,
    rules: [{ required: false, message: '', trigger: 'blur' },{  max: 255, message: '输入不能超过255位', trigger: 'blur' }],
},

{
    label: '主要投资方向',
    field: 'investDirection',
    formtype: "select",
    options: [
        {
            label: "高端智能制造",
            value: "高端智能制造"
        },
        {
            label: "移动互联网",
            value: "移动互联网"
        },
        {
            label: "新材料",
            value: "新材料"
        },
        {
            label: "生物医药和健康",
            value: "生物医药和健康"
        },
        {
            label: "文化创新",
            value: "文化创新"
        },
        {
            label: "新能源和环保",
            value: "新能源和环保"
        },
        {
            label: "军民融合",
            value: "军民融合"
        },
        {
            label: "现代服务",
            value: "现代服务"
        },
        {
            label: "食品和家电",
            value: "食品和家电"
        },
        {
            label: "其他",
            value: "其他"
        },
    ],
    selectType: true,
    require: false
},

{
    label: '产品备案编号',
    formtype: "",
    field: "productType",
    require: false,
},
{
    label: '是否完成湖南省发展和改革委员会备案',
    formtype: "select",
    options: [{
        label: "是",
        value: "是"
    },
    {
        label: "否",
        value: "否"
    }
    ],
    field: "hunanFgwRegiste",
    require: false
},
{
    label: '小镇经办人员',
    formtype: "",
    field: "inviteCode",
    require: false,
    rules: [{ required: false, message: '', trigger: 'blur' },{ max: 255, message: '输入不能超过255位', trigger: 'blur' }],

},



{
    label: "是否工位注册",
    formtype: "select",
    options: [{
        label: "是",
        value: '1'
    },
    {
        label: "否",
        value: '0'
    }
    ],
    field: "registeIs",//everlasting
    require: false
}, {
    label: "注册地址",
    formtype: "",
    field: "registeAddress",
    require: false,
    rules: [{ required: false, message: '', trigger: 'blur' },{ max: 255, message: '不能超过255位', trigger: 'blur' }],
},
{
    label: '工位注册托管期限',
    formtype: "date",
    field: "registeExpireDate",
    require: false
}
];

//step2
export const AgencyStep2 = [{
    label: '出资人名称',
    field: 'investorName',
    formtype: "",
    require: false
}, {
    label: '出资人性质',
    field: 'investorCharacter',
    formtype: "select",
    options: [],
    require: false
}, {
    label: '身份证号码/统一社会信用代码',
    field: 'investorNo',
    formtype: "",
    require: false
}, {
    label: '认缴出资额(万元)',
    field: 'capture',
    inputType: "number",
    formtype: "",
    require: false
}, {
    label: '认缴出资比例(%)',
    field: 'capturePercent',
    inputType: "number",
    formtype: "",
    disabled:true,
    require: false,
},
// {
//   label: '出资人类别',
//   field: 'registedM3Paid',
//   inputType:"number",
//   formtype: "",
//   require: false
// }, 
{
    label: '出资人类别',
    formtype: 'select',
    field: 'investorType',
    options: [
        {
            label: "普通合伙人",
            value: "普通合伙人"
        },
        {
            label: "有限合伙人",
            value: "有限合伙人"
        },

        {
            label: "其他",
            value: "其他"
        },
    ],
    require: false

},
{
    label: "是否符合合格投资者条件",
    formtype: "select",
    options: [{
        label: "是",
        value: "1"
    },
    {
        label: "否",
        value: "0"
    }
    ],
    field: "qualified",
    require: false
},
    // {
    //     label: '联系电话',
    //     field: 'contactTel',
    //     formtype: "",
    //     require: false
    // },
    // {
    //     label: '简介',
    //     field: 'abstractInfo',
    //     inputType: "textarea",
    //     formtype: "",
    //     class: "infoLine",
    //     autosize: { minRows: 2, maxRows: 5 },
    //     require: false
    // }
];